export const MODULE = 'sales';
